import React from "react";
import Lottie from "lottie-react";
import { wakingAnimationData } from "../models/wakingAnimationData";
import { Box, Stack } from "@mui/material";
import { ReactComponent as Logo } from "../images/rs-logo.svg";

export const WakingUpAnimation = () => (
  <Stack justifyContent={"space-between"} alignItems={"stretch"} width={"100%"}>
    <Stack direction={"row"} justifyContent={"center"}>
      <Logo width={"103px"} style={{ margin: "4px 30px" }} />
    </Stack>
    <Stack
      flex={1}
      justifyContent={"center"}
      alignItems={"center"}
      width={"100%"}
      height={"100%"}
    >
      <Lottie animationData={wakingAnimationData} loop={true} />
      <Box
        sx={{
          color: "#9A9EA5",
          fontFamily: "sans-serif",
          fontSize: "22px",
          fontWeight: 600,
        }}
      >
        Cloud Web App is waking up...
      </Box>
    </Stack>
  </Stack>
);
